import { Box } from '@mui/material';

import TccChilli from '@public/assets/svg/tcc-chilli.svg';

export const GetFilledChilli = () => {
  return (
    <Box
      sx={{
        display: 'inline-block',
        position: 'relative',
        height: '26px',
        width: '20px',
      }}
    >
      <TccChilli />
    </Box>
  );
};
